import BaseService from '@/services/BaseService'

class CuttingService {
    url = 'customer-management'

    constructor() {
        this.httpService = new BaseService();
    }

    getDecors() {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.url}`,
            method: 'GET'
        }
        console.log('Decor')
        return this.httpService.service(settings)
    }

    getDecorsSearch(val) {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.url}/storage-cards/pm?searchText=${val}`,
            method: 'GET'
        }
        console.log('Decor')
        return this.httpService.service(settings)
    }

    getHp(val, materialThickness) {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.url}/storage-cards/hp?searchText=${val}&materialThickness=${materialThickness}`,
            method: 'GET'
        }
        console.log('hp search')
        return this.httpService.service(settings)
    }

    getDecorsHmSearch(materialId, materialThickness) {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.url}/storage-cards/Assign/Hp?materialId=${materialId}&materialThickness=${materialThickness}`,
            method: 'GET'
        }
        console.log('Decor')
        return this.httpService.service(settings)
    }
}

export default CuttingService